export default __webpack_public_path__ + "static/img/dashboard_icon.d1c36e7.svg";